/**
 * CompanyBrand — 사이드바 브랜드 영역.
 *
 * 활성 회사에 로고(settings.logoKey)가 설정돼 있으면 그 로고를, 없으면 기본 제품 브랜드
 * (Teamer eQMS)를 표시함. 로고는 공용 훅 useCompanyLogo(인증 blob, 캐시 공유)로 로드한다(<img> 401 회피).
 * 로고 변경 시 useUpdateCompanySelf 가 ["company","self"] 캐시를 무효화 → 새 logoKey 로 헤더가 자동 갱신됨.
 */
import { useTranslation } from "react-i18next";

import { useCompanyLogo } from "@/lib/queries/useCompanySelf";

export function CompanyBrand() {
  const { t } = useTranslation();
  const { logoUrl, companyName } = useCompanyLogo();

  if (logoUrl) {
    // 브랜드 영역(sb-brand, height=--topbar-h 64px)에 맞춰 로고를 크게 표시.
    // 전역 `.sb-brand img { height: 26px }` 를 인라인 height 로 오버라이드(objectFit 으로 비율 유지).
    return (
      <img
        src={logoUrl}
        alt={companyName ?? t("app.brand", "Teamer")}
        style={{
          height: "100%",
          width: "100%",
          objectFit: "contain",
          objectPosition: "left center",
          display: "block",
        }}
      />
    );
  }

  return (
    <>
      <span
        style={{
          fontSize: 18,
          fontWeight: 800,
          letterSpacing: "-0.02em",
          color: "var(--brand)",
        }}
      >
        {t("app.brand", "Teamer")}
      </span>
      <span className="sub">{t("app.brandSub", "eQMS")}</span>
    </>
  );
}

export default CompanyBrand;
